
import React, { useState } from "react";

import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    InputBase,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";


import { Add, DescriptionOutlined } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import CustomDataTable from "../../components/DataTable";

import Loader from "../../components/Loader";
import { toast } from "react-toastify";

// import { Icons } from "../../assets/Svgs";
import { useDeleteCategoryMutation, useFetchCategoriesQuery } from "../../store/services/categoriesService";
import { BASE_URL, IMAGE_URL } from "../../Api/constants";
import { Layout } from "../../components";
import AddCategoryDialog from "./NewCategory";
import { Image } from "antd";
import ActionMenu from "../../components/ActionMenu";
import EditCategoryDialog from "./EditCategory";

const Categories = () => {
    const theme = useTheme();
    const words = useSelector((state) => state.authReducer.words);
    const { data, isLoading, error } = useFetchCategoriesQuery();
    const [deleteCategory, { isLoading: isDeleting }] = useDeleteCategoryMutation();
    const [open, setOpen] = useState(false);


    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [editModal, setEditModal] = useState(false);
    const [editCategory, setEditCategory] = useState({});

    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteCustomerId, setDeleteCustomerId] = useState(null);


    const filteredData = data?.data?.filter((category) =>
        category.name.toLowerCase().includes(search.toLowerCase())
    );


    const columns = [
        {
            dataIndex: "image",
            title: words["image"],
            render: (value) => (
                <Image
                    src={IMAGE_URL + value || "/default-category.png"}
                    alt="Category"
                    style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                />
            ),
        },
        { dataIndex: "name", title: words["Category Name"] },
        { dataIndex: "ar_name", title: words["Arabic Name"] },
        { dataIndex: "created_at", title: words["Created at"], render: (value) => new Date(value).toLocaleDateString(), },
        {
            dataIndex: "ads_count",
            title: words["Total services"],
            render: (value, record) => (
                <Box
                    sx={{
                        backgroundColor: '#4CAF50',
                        //  : "#4CAF50",
                        color: "#fff",
                        padding: "7px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        fontFamily: "PMe",
                        fontSize: 12,
                        maxWidth: 60,
                    }}
                >
                    {value}
                </Box>
            ),
        },

        {
            field: "Action",
            title: words["action"],
            render: (value, record) => (
                <ActionMenu
                    onAction={(action) => {
                        if (action === "edit") {
                            setEditCategory(record);
                            setEditModal(true);
                        } else if (action === "delete") {
                            setDeleteCustomerId(record.id); // Set the selected customer ID
                            setDeleteModal(true); // Open delete confirmation dialog
                        }
                    }}
                    menuItems={[
                        { label: words["Edit"], action: "edit" },
                        { label: words["Delete"], action: "delete" },
                    ]}
                />
            ),
        }


    ];


    const handleDeleteCustomer = async () => {
        if (!deleteCustomerId) return;
        try {
            await deleteCategory(deleteCustomerId).unwrap();
            toast.success("Customer deleted successfully!");
            setDeleteModal(false); // Close the dialog
        } catch (error) {
            toast.error("Failed to delete customer. Please try again.");
            console.error(error);
        }
    };


    return (
        <Layout pageTitle="Categories" >
            <Box sx={{ padding: "16px", backgroundColor: "#F5F5F5" }}>
                {/* <Loader open={isLoading} /> */}

                <Button
                    onClick={() => setOpen(true)}
                    // variant="contained"
                    startIcon={<Add />}
                    sx={{
                        backgroundColor: '#CD454A',
                        fontSize: 12,
                        color: "white",
                        fontFamily: "PMe",
                        borderRadius: "20px",
                        padding: "8px 16px",
                        textTransform: "none",
                    }}
                >
                    {words["New category"]}
                </Button>



            </Box>

            {/* Data Table */}
            <Box sx={{ paddingRight: '16px', paddingLeft: '16px', backgroundColor: '#fff' }}>
                {isLoading ? (
                    <Loader />
                ) : (

                    <CustomDataTable
                        data={filteredData || []} // Use filtered data
                        columns={columns}
                        totalPages={data?.data?.last_page || 1}
                        currentPage={currentPage}
                        onPageChange={(page) => setCurrentPage(page)}

                    />
                )}
            </Box>

            <AddCategoryDialog open={open} onClose={() => setOpen(false)} />
            <EditCategoryDialog data={editCategory} open={editModal} onClose={() => setEditModal(false)} />

            <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
                <DialogTitle
                    sx={{ fontFamily: 'PSBo' }}
                >Are you sure?</DialogTitle>
                <DialogContent>
                    <Typography
                        sx={{ fontFamily: 'PRe' }}
                    >
                        Are you sure you want to delete this category?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setDeleteModal(false)}
                        variant="outlined"
                        sx={{
                            borderRadius: "20px",
                            fontSize: 12,
                            textTransform: "none",
                            fontFamily: "PMe",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDeleteCustomer}
                        variant="contained"
                        disabled={isDeleting}
                        sx={{
                            backgroundColor: 'red',
                            fontSize: 12,
                            color: "white",
                            borderRadius: "20px",
                            padding: "8px 16px",
                            textTransform: "none",
                            fontFamily: "PMe",
                        }}
                    >
                        {isDeleting ? "Deleting..." : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Layout >
    );
};

export default Categories;



